import React from 'react'

interface RedCrossIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string
}

const RedCrossIcon: React.FC<RedCrossIconProps> = ({ className }) => {
return(
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M26.2027 19L37.0057 8.19699C38.3314 6.87131 38.3314 4.72193 37.0057 3.39517L34.6048 0.994261C33.2791 -0.33142 31.1298 -0.33142 29.803 0.994261L19 11.7973L8.19699 0.994261C6.87131 -0.33142 4.72193 -0.33142 3.39517 0.994261L0.994261 3.39517C-0.33142 4.72085 -0.33142 6.87023 0.994261 8.19699L11.7973 19L0.994261 29.803C-0.33142 31.1287 -0.33142 33.2781 0.994261 34.6048L3.39517 37.0057C4.72085 38.3314 6.87131 38.3314 8.19699 37.0057L19 26.2027L29.803 37.0057C31.1287 38.3314 33.2791 38.3314 34.6048 37.0057L37.0057 34.6048C38.3314 33.2791 38.3314 31.1298 37.0057 29.803L26.2027 19Z" fill="#F2543F"/>
  </svg>
)
}
export default RedCrossIcon
